import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import { useFormElement } from '../../composables/useFormElement';
import { makeUseFormElementEmits, makeUseFormElementProps } from '../../composables/useFormElementInterfaces';
import { FieldModel } from '../../interfaces';
import { useBaseFieldValues } from '../../composables/useBaseFieldValues';
import { EyeIcon, EyeCrossedIcon } from '../../../icons/components';
import { useTextFormFieldMethods } from '../../composables/useTextFormFieldMethods';
import { FormIconClickEvent } from '../../interfaces';
import InputGroupWrapper from '../common/InputGroupWrapper.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordFormField',
  props: makeUseFormElementProps<FieldModel, string>(),
  emits: makeUseFormElementEmits<string>(),
  setup(__props, { emit }) {

const props = __props;





const showPassword = ref(false);

const formElement = useFormElement<FieldModel, string>({
  emit,
  props,
});

const {
  inputName,
  readonly,
  inputMode,
  autocomplete,
  placeholder,
  inputClass,
  inputErrorClass,
  fieldErrorsShown,
  valueToInputFn,
} = useBaseFieldValues(formElement);

const { onBlur, onKeyPress, setValue } = useTextFormFieldMethods(formElement);

const { model, field, getSlotName, getModelState, emitFormEvent } = formElement;

const stringVal = computed(() => valueToInputFn.value(field.value.$model));

const icon = computed(() => {
  if (!getModelState('allowShowPassword')) {
    return null;
  }

  return showPassword.value ? EyeCrossedIcon : EyeIcon;
});

function onIconClick(name: string) {
  showPassword.value = !showPassword.value;

  emitFormEvent({
    event: 'form-icon-clicked',
    name,
  } as FormIconClickEvent<string>);
}

const fieldType = computed(() => (showPassword.value ? 'text' : 'password'));

return { __sfc: true,props, emit, showPassword, formElement, inputName, readonly, inputMode, autocomplete, placeholder, inputClass, inputErrorClass, fieldErrorsShown, valueToInputFn, onBlur, onKeyPress, setValue, model, field, getSlotName, getModelState, emitFormEvent, stringVal, icon, onIconClick, fieldType, InputGroupWrapper }
}

})